import * as React from 'react';
import * as moment from 'moment';
import { TabsWrapper, PillWrapper } from './styles';

interface IProps {
    tabKey: string;
    subTabKey: string;
}

class Tabs extends React.Component<IProps, any> {
    constructor(props: IProps) {
        super(props);
    }

    render() {
        const year = new Date().getFullYear();
        const currentMonth = moment().month();
        const previousMonth = currentMonth == 0 ? 12 : (currentMonth + 1) - 1;

        return (
            <TabsWrapper className='xtabs' style={{ paddingTop: 0 }}>
                <ul className='nav nav-tabs' style={{ marginBottom: 0 }}>
                    <li className={this.props.tabKey == 'INVOICING' ? 'active' : ''}><a href={'/admin/invoice/index'}><span>Invoices</span></a></li>
                    <li className={this.props.tabKey == "PAYABLE" ? 'active' : ''}><a href={'/admin/invoice/payable/nephrectomy'}><span>Accounts Payable</span></a></li>
                </ul>

                {this.props.tabKey == 'PAYABLE' && (
                    <div className='nav nav-tabs' style={{ backgroundColor: '#ccc', paddingTop: 5, paddingLeft: 5 }}>

                        <PillWrapper className={this.props.subTabKey == 'NEPHRECTOMY' ? 'on' : ''}>
                            <a href={'/admin/invoice/payable/nephrectomy'}>
                                <span>Center Nephrectomy</span>
                            </a>
                        </PillWrapper>

                        <PillWrapper className={this.props.subTabKey == 'EVAL' ? 'on' : ''}>
                            <a href={'/admin/invoice/payable/donor-eval'}>
                                <span>Donor Evals</span>
                            </a>
                        </PillWrapper>

                        <PillWrapper className={this.props.subTabKey == 'PACKAGING' ? 'on' : ''}>
                            <a href={'/admin/invoice/payable/opo-packaging'}>
                                <span>OPO Packaging</span>
                            </a>
                        </PillWrapper>

                    </div>
                )}


                {this.props.tabKey == 'INVOICING' && (
                    <div className='nav nav-tabs' style={{ backgroundColor: '#ccc', paddingTop: 5, paddingLeft: 5 }}>

                        <PillWrapper className={this.props.subTabKey == 'INDEX' ? 'on' : ''}>
                            <a href={'/admin/invoice/index'}>
                                <span>Invoicing</span>
                            </a>
                        </PillWrapper>

                        <PillWrapper className={this.props.subTabKey == 'LINE-ITEMS' ? 'on' : ''}>
                            <a href={`/admin/invoice/line-items`}>
                                <span>Line Items</span>
                            </a>
                        </PillWrapper>

                        <PillWrapper className={this.props.subTabKey == 'COLLECTIONS' ? 'on' : ''}>
                            <a href={`/admin/invoice/collections`}>
                                <span>Collections</span>
                            </a>
                        </PillWrapper>

                    </div>
                )}


            </TabsWrapper>
        );
    }
}

export default Tabs;